import { NgModule } from '@angular/core';

import { MatTooltipModule } from "@angular/material/tooltip"

import { MatInputModule } from "@angular/material/input"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatProgressBarModule } from "@angular/material/progress-bar"
import { TextFieldModule } from "@angular/cdk/text-field"

import { CommonModule } from '@angular/common';
import { TemplateListComponent } from './pages/templates/template-list/template-list.component';
import { TemplateEditComponent } from './pages/templates/template-edit/template-edit.component';
import { TemplateCopyDialogComponent } from './pages/templates/template-copy-dialog/template-copy-dialog.component';
import { ChannelListComponent } from './pages/channels/channel-list/channel-list.component';
import { DistributionListComponent } from './pages/distribution-lists/distribution-list/distribution-list.component';
import { DistributionListEditComponent } from './pages/distribution-lists/distribution-list-edit/distribution-list-edit.component';
import { CommunicationsRoutingModule } from './communications-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '../core/core.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import * as fromCommunications from './store';
import { WorkflowEffects } from 'src/app/modules/communications/store/workflow/workflow.effects';
import { CommunicationsEffects } from 'src/app/modules/communications/store/communications/communications.effects';
import { TopoEmailEditComponent } from './pages/channels/channel-edit/topo-email-edit/topo-email-edit.component';
import { SlackEditComponent } from './pages/channels/channel-edit/slack-edit/slack-edit.component';
import { MicrosoftTeamsEditComponent } from './pages/channels/channel-edit/microsoft-teams-edit/microsoft-teams-edit.component';
import { EverbridgeEditComponent } from './pages/channels/channel-edit/everbridge-edit/everbridge-edit.component';
import { SendGridEmailEditComponent } from './pages/channels/channel-edit/sendgrid-email-edit/sendgrid-email-edit.component';
import { TwilioEditComponent } from './pages/channels/channel-edit/twilio-edit/twilio-edit.component';
import { NewDistributionListComponent } from './pages/distribution-lists/new-distribution-list/new-distribution-list.component';
import { WorkflowListComponent } from './pages/workflow/workflow-list/workflow-list.component';
import { WorkflowEditComponent } from './pages/workflow/workflow-edit/workflow-edit.component';
import { WorkflowRuleEditComponent } from './pages/workflow/workflow-rules/workflow-rule-edit/workflow-rule-edit.component';
import { NavigationRuleEditComponent } from './pages/workflow/workflow-rules/actions/navigation-edit/navigation-edit.component';
import { CommunicationsHeaderBar } from './components/communications-header-bar/communications-header-bar.component';
import { WorkflowStepEdit } from './components/workflow/workflow-step-edit/workflow-step-edit.component';
import { WorkflowRuleActionEditDirective } from './pages/workflow/workflow-rules/workflow-rule-action-edit.directive';
import { TeamMemberSelectComponent } from './components/workflow/team-member-select/team-member-select.component';
import { NotificationLeftDrawerComponent } from './components/left-drawer/left-drawer.component';
import { NotificationListComponent } from './pages/notifications/notification-list/notification-list.component';
import { TemplateChannelsSelection } from './components/template/channels-selection/channels-selection.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgChartsModule } from 'ng2-charts';
import { TemplateDesignElementsSelection } from './components/template/designer/design-elements-selection/design-elements-selection.component';
import { TemplateDesignElementDirective } from './components/template/designer/design-elements/design-elements.directive';
import { TemplateDesignImageElement } from './components/template/designer/design-elements/controls/image-control/image-control.component';
import { TemplateDesignTextElement } from './components/template/designer/design-elements/controls/text-control/text-control.component';
import { TemplateDesigner } from './components/template/designer/designer/designer.component';
import { TemplateDesignDividerElement } from './components/template/designer/design-elements/controls/divider-control/divider-control.component';
import { TemplateDesignButtonElement } from './components/template/designer/design-elements/controls/button-control/button-control.component';
import { TemplateDesignMessageTextElement } from './components/template/designer/design-elements/controls/message-text-control/message-text-control.component';
import { TemplateDesignConfirmationElement } from './components/template/designer/design-elements/controls/confirmation-control/confirmation-control.component';
import { TemplateDesignFormFieldElement } from './components/template/designer/design-elements/controls/form-field-control/form-field-control.component';
import { TemplateDesignAttachmentsElement } from './components/template/designer/design-elements/controls/attachments-control/attachments-control.component';
import { TemplateDesignTimelineElement } from './components/template/designer/design-elements/controls/timeline-control/timeline-control.component';
import { TemplateDesignMapElement } from './components/template/designer/design-elements/controls/map-control/map-control.component';
import { TemplateDesignAssetsElement } from './components/template/designer/design-elements/controls/assets-control/assets-control.component';
import { NewNotificationComponent } from './pages/notifications/new-notification/new-notification.component';
import { TwilioTtsEditComponent } from './pages/channels/channel-edit/twilio-tts-edit/twilio-tts-edit.component';
import { WorkflowStepActionEdit } from './components/workflow/workflow-step-action-edit/workflow-step-action-edit.component';
import { ActionLabelTranslationsComponent } from './pages/workflow/action-label-translations/action-label-translations.component';

import { NotificationEditComponent } from './pages/notifications/notification-edit/notification-edit.component';
import { NotificationDashboardComponent } from './components/notification/notification-dashboard/notification-dashboard.component';
import { NotificationRecipientsComponent } from './components/notification/notification-recipients/notification-recipients.component';
import { NotificationDetailsComponent } from './components/notification/notification-details/notification-details.component';
import { WorkflowGeneralTransitionSelectComponent } from './components/workflow/workflow-gen-transition-select/workflow-gen-transition-select.component';
import { StatusPerChannelCellComponent } from './components/notification/notification-recipients/column-renderers/status-per-channel/status-per-channel-cell.component';
import { RecipientAddresslCellComponent } from './components/notification/notification-recipients/column-renderers/recipient-address/recipient-address-cell.component';
import { TtsNotificationMessageControlComponent } from './components/template/designer/design-elements/controls/tts-notification-message-control/tts-notification-message-control.component';
import { NotificationResponsesComponent } from './components/notification/notification-responses/notification-responses.component';
import { TextWithStatusCellComponent } from './components/notification/notification-recipients/column-renderers/text-with-status/text-with-status-cell.component';
import { TtsConfirmationQuestionComponent } from './components/template/designer/design-elements/controls/tts-confirmation-question/tts-confirmation-question.component';
import { TtsTextControlComponent } from './components/template/designer/design-elements/controls/tts-text-control/tts-text-control.component';
import { PieChartComponent } from './components/notification/charts/pie-chart/pie-chart.component';
import { BarChartComponent } from './components/notification/charts/bar-chart/bar-chart.component';
import { DeliveryStatusChartWidgetComponent } from './components/notification/notification-dashboard/widgets/delivery-status/delivery-status-chart-widget.component';
import { ResponseStatusChartWidgetComponent } from './components/notification/notification-dashboard/widgets/response-status/response-status-chart-widget.component';
import { ResponsesOverTimeChartWidgetComponent } from './components/notification/notification-dashboard/widgets/responses-over-time/responses-over-time-chart-widget.component';
import { SmsNotificationMessageControl } from './components/template/designer/design-elements/controls/sms-notification-message-control/sms-notification-message-control.component';
import { SlackTemplateDesignConfirmationElement } from './components/template/designer/design-elements/controls/slack-confirmation-control/slack-confirmation-control.component';
import { SetFieldValueRuleEditComponent } from './pages/workflow/workflow-rules/actions/set-field-value-edit/set-field-value-edit.component';
import { NotificationRuleEditComponent } from './pages/workflow/workflow-rules/actions/notification-edit/notification-edit.component';
import { DatasetFieldTemplateComponent } from './components/template/dataset-field-template/dataset-field-template.component';
import { WhatsAppEditComponent } from './pages/channels/channel-edit/whatsapp-edit/whatsapp-edit.component';
import { RecipientDetailsComponent } from './components/recipient-details/recipient-details.component';
import { SmsConfirmationControlComponent } from './components/template/designer/design-elements/controls/sms-confirmation-control/sms-confirmation-control.component';
import { WhatsappConfirmationControlComponent } from './components/template/designer/design-elements/controls/whatsapp-confirmation-control/whatsapp-confirmation-control.component';
import { WhatsappNotificationMessageControlComponent } from './components/template/designer/design-elements/controls/whatsapp-notification-message-control/whatsapp-notification-message-control.component';
import { HeaderControlComponent } from './components/template/designer/design-elements/controls/header-control/header-control.component';
import { TemplateDesignNotificationStatusElement } from './components/template/designer/design-elements/controls/notification-status-control/notification-status-control.component';
import { HorizonSmsEditComponent } from './pages/channels/channel-edit/horizon-sms-edit/horizon-sms-edit.component';
import { SmsTextControlComponent } from './components/template/designer/design-elements/controls/sms-text-control/sms-text-control.component';
import { NotificationTimelineChartWidgetComponent } from './components/notification/notification-dashboard/widgets/notification-timeline/notification-timeline-chart-widget.component';
import { HorizonMobilePushEditComponent } from './pages/channels/channel-edit/horizon-mobile-push-edit/horizon-mobile-push-edit.component';
import { PushTextControlComponent } from './components/template/designer/design-elements/controls/push-text-control/push-text-control.component';
import { RecipientAssetsSelectionListComponent } from './components/recipient-assets-selection-list/recipient-assets-selection-list.component';
import { RecipientAssetsSelectionComponent } from './components/recipient-assets-selection/recipient-assets-selection.component';
import { NotificationDocumentSelectionComponent } from './components/notification-document-selection/notification-document-selection.component';
import { GwtsMobileEditComponent } from './pages/channels/channel-edit/gwts-mobile-edit/gwts-mobile-edit.component';
import { GwtsConfirmationControlComponent } from './components/template/designer/design-elements/controls/gwts-confirmation-control/gwts-confirmation-control.component';
import { GwtsNotificationMessageControlComponent } from './components/template/designer/design-elements/controls/gtws-notification-message-control/gwts-notification-message-control.component';

import { WorkflowRuleDisplayComponent } from '@app/features/workflow/components/workflow-rule-display/workflow-rule-display.component';
import { FormatDatePipe, SafeUrlPipe, SafeHtmlPipe } from '@app/shared/pipes';
import { TemplateGroupsCRUDModalComponent } from './components/template-groups-crud-modal/template-groups-crud-modal.component';
import { TemplateSelectExpansionPanelComponent } from './pages/notifications/new-notification/template-select-expansion-panel/template-select-expansion-panel.component';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';

@NgModule({
  declarations: [
    TemplateListComponent,
    ChannelListComponent,
    DistributionListComponent,
    TemplateEditComponent,
    TemplateCopyDialogComponent,
    TopoEmailEditComponent,
    SlackEditComponent,
    MicrosoftTeamsEditComponent,
    EverbridgeEditComponent,
    SendGridEmailEditComponent,
    TwilioEditComponent,
    HorizonSmsEditComponent,
    HorizonMobilePushEditComponent,
    GwtsMobileEditComponent,
    NewDistributionListComponent,
    DistributionListEditComponent,
    WorkflowListComponent,
    WorkflowEditComponent,
    WorkflowRuleEditComponent,
    WorkflowGeneralTransitionSelectComponent,
    NavigationRuleEditComponent,
    SetFieldValueRuleEditComponent,
    NotificationRuleEditComponent,
    CommunicationsHeaderBar,
    WorkflowStepEdit,
    WorkflowStepActionEdit,
    WorkflowRuleActionEditDirective,
    TeamMemberSelectComponent,
    NotificationLeftDrawerComponent,
    NotificationListComponent,
    TemplateChannelsSelection,
    TemplateDesignElementsSelection,
    TemplateDesignElementDirective,
    TemplateDesignImageElement,
    TemplateDesignTextElement,
    TemplateDesignDividerElement,
    TemplateDesignButtonElement,
    TemplateDesignMessageTextElement,
    TemplateDesignConfirmationElement,
    TemplateDesignFormFieldElement,
    TemplateDesignAttachmentsElement,
    TemplateDesignNotificationStatusElement,
    TemplateDesignTimelineElement,
    TemplateDesignMapElement,
    TemplateDesignAssetsElement,
    TemplateDesigner,
    TemplateChannelsSelection,
    NewNotificationComponent,
    RecipientDetailsComponent,
    RecipientAssetsSelectionComponent,
    RecipientAssetsSelectionListComponent,
    TwilioTtsEditComponent,
    ActionLabelTranslationsComponent,
    NotificationEditComponent,
    NotificationDashboardComponent,
    NotificationRecipientsComponent,
    NotificationDetailsComponent,
    StatusPerChannelCellComponent,
    RecipientAddresslCellComponent,
    TtsNotificationMessageControlComponent,
    NotificationResponsesComponent,
    TextWithStatusCellComponent,
    TtsConfirmationQuestionComponent,
    TtsTextControlComponent,
    PieChartComponent,
    BarChartComponent,
    DeliveryStatusChartWidgetComponent,
    ResponseStatusChartWidgetComponent,
    ResponsesOverTimeChartWidgetComponent,
    NotificationTimelineChartWidgetComponent,
    SmsNotificationMessageControl,
    SlackTemplateDesignConfirmationElement,
    WhatsAppEditComponent,
    DatasetFieldTemplateComponent,
    SmsConfirmationControlComponent,
    SmsTextControlComponent,
    PushTextControlComponent,
    WhatsappConfirmationControlComponent,
    GwtsConfirmationControlComponent,
    GwtsNotificationMessageControlComponent,
    WhatsappNotificationMessageControlComponent,
    HeaderControlComponent,
    NotificationDocumentSelectionComponent
    
  ],
  imports: [
    CommonModule,
    CommunicationsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    ScrollingModule,
    MatDatepickerModule,
    MatMomentDateModule,
    StoreModule.forFeature(fromCommunications.communicationsModuleKey, fromCommunications.reducers),
    EffectsModule.forFeature([CommunicationsEffects, WorkflowEffects]),
    FlexLayoutModule,
    CoreModule,
    NgxSpinnerModule,
    NgChartsModule,
    TranslateModule.forChild({
      extend: true
    }),
    WorkflowRuleDisplayComponent,
    SafeUrlPipe,
    SafeHtmlPipe,
    FormatDatePipe,
    TemplateGroupsCRUDModalComponent,
    TemplateSelectExpansionPanelComponent,
    MatTooltipModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressBarModule,
    TextFieldModule,
  ],
  exports: [
    NewNotificationComponent,
    NotificationEditComponent,
    TemplateChannelsSelection,
    TemplateDesignElementsSelection,
    TemplateDesignElementDirective,
    TemplateDesignImageElement,
    TemplateDesignTextElement,
    TemplateDesignDividerElement,
    TemplateDesignButtonElement,
    TemplateDesignMessageTextElement,
    TemplateDesignConfirmationElement,
    TemplateDesignFormFieldElement,
    TemplateDesignAttachmentsElement,
    TemplateDesignTimelineElement,
    TemplateDesignMapElement,
    TemplateDesignAssetsElement,
    TemplateDesigner,
    TemplateChannelsSelection,
    HeaderControlComponent
  ]
})
export class CommunicationsModule { }
